import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import FeedPage from "./pages/FeedPage";
import LoginPage from "./pages/LoginPage";
import AdminLayout from "./pages/AdminLayout";
import DashboardPage from "./pages/DashboardPage";
import SourcesPage from "./pages/SourcesPage";
import InstagramPage from "./pages/InstagramPage";
import LogsPage from "./pages/LogsPage";
import RequireAuth from "./components/RequireAuth";

const routerBaseName = process.env.PUBLIC_URL || "/";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter basename={routerBaseName}>
          <Routes>
            <Route path="/" element={<FeedPage />} />
            <Route path="/admin/login" element={<LoginPage />} />
            <Route
              path="/admin"
              element={
                <RequireAuth>
                  <AdminLayout />
                </RequireAuth>
              }
            >
              <Route index element={<DashboardPage />} />
              <Route path="sources" element={<SourcesPage />} />
              <Route path="instagram" element={<InstagramPage />} />
              <Route path="logs" element={<LogsPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
